import React from 'react';
import PropTypes from 'prop-types';

import { AddIcon, CloseIcon } from '$partials/icon';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Checkbox = ({
    checked,
    label,
    value,
    register = () => {},
    registerName,
    ...remainingProps
}) => {

    const bgColor = checked ? 'bg-black' : 'bg-peach';
    const textColor = checked ? 'white' : 'black';

    return (
        <div className={`${bgColor} ${textColor} custom-checkbox inline-flex items-center px5 py2 mb-2px mr-2px expand-interaction`}>
            <label htmlFor={value}>{label}</label>
            <input
                className='property-alert-checkbox expand-interaction__action cursor-pointer'
                id={value}
                name={value}
                type='checkbox'
                value={value}
                {...register(registerName)}
                {...remainingProps}/>
            <span
                aria-hidden={true}
                className='ml5 font-0 line-height-0'>
                {checked ? <CloseIcon/> :<AddIcon/> }
            </span>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
    register: PropTypes.func,
    registerName: PropTypes.string,
    renderIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.array
    ]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};

Checkbox.propTypes = propTypes;

export default Checkbox;
